import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

/* REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setSessionUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { nav("/login", { replace: true }); return; }

    axios
      .post(`${API}/auth/session`, { session_id }, { withCredentials: true })
      .then(({ data }) => {
        setSessionUser(data.user);
        // Strip the hash so a refresh doesn't retry the exchange
        window.history.replaceState({}, "", "/");
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}!`);
        nav(data.user.role === "groomer" ? "/groomer" : "/client", { replace: true });
      })
      .catch(() => {
        toast.error("Sign-in failed. Please try again.");
        nav("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2] grid place-content-center">
      <div className="text-center">
        <div className="w-14 h-14 rounded-2xl bg-[#F5E6CF] grid place-content-center text-[#C85A17] mx-auto">
          <Sparkles className="w-6 h-6 animate-pulse"/>
        </div>
        <p className="mt-4 text-sm text-[#6B625B]">Signing you in…</p>
      </div>
    </div>
  );
}
